import * as React from 'react';
import { Editor } from '../inclinationmodals/tinymce-react/lib/cjs';

interface Props {
    onSave: (content: string) => void;
    content: string;
    extra?: any;
    defaultContent?: string;
}

interface State {
    content: string;
    defaultContent?: string;
}

export class PonderaEditor extends React.Component<Props, State> {
    private editor: any;

    constructor(props: Props) {
        super(props);

        var defaultContent = !this.props.defaultContent ? undefined : this.props.defaultContent;

        this.state = {
            content: this.props.content.trim().length === 0 && defaultContent ? defaultContent : this.props.content.trim(),
            defaultContent: defaultContent
        };
    }

    onHide(): any {
        var content = this.state.content;
        if (content.startsWith('<p>&nbsp;</p>')) {
            content = content.replace('<p>&nbsp;</p>', '');
        }
        if (content.endsWith('<p>&nbsp;</p>')) {
            content = content.substr(0, content.length - ('<p>&nbsp;</p>').length);
        }
        this.setState(
            {
                content
            },
            () => {
                this.props.onSave(content);
            });        
    }

    handleEditorChange = (content: string) => {
        this.setState({ content });
        this.props.onSave(content);
    }

    resetToDefault = () => {
        this.setState({ content: this.state.defaultContent! });
    }

    setup(ed: any) {
        ed.addButton('zigzag', {
            text: 'Zig Zag',
            icon: false,
            onclick: () => {
                ed.insertContent('<table class="table table-left-right-content table-zig-zag"><tbody><tr><td class="modal-content-container container-left" style="width: 50%;"><p>Left Content</p></td><td class="modal-content-container container-right"><p>Right Content</p></td></tr></tbody></table>');
            }
        });
        ed.addButton('zigzagfull', {
            text: 'Zig Zag Full',
            icon: false,
            onclick: () => {
                ed.insertContent('<div class="zig-zag-full"><p>Left Content</p></div>');
            }
        });
    }

    render() {
        return (
            <>
                <Editor
                    ref={(e: any) => this.editor = e}
                    value={this.state.content}
                    init={{ minHeight: '300px', height: '300px', plugins: 'link image code table lists textcolor', toolbar: 'undo redo | bold italic forecolor | alignleft aligncenter alignright | bullist numlist | code | zigzag | zigzagfull', setup: this.setup, skin_url: '/tinymce/skins/lightgray', theme_url: '/tinymce/themes/modern/theme.min.js' }}
                    onEditorChange={this.handleEditorChange}
                />
                {this.props.extra}
            </>);
    }
}


// WEBPACK FOOTER //
// ./src/components/common/PonderaEditor.tsx